export { default, A11yPageTitle } from './Page';
